function buildDerivedIdentity(attributes) {
  return {
    isDerived: true,
    firstName: attributes.firstName,
    lastName: attributes.lastName,
    email: attributes.email,
  };
}

function buildOptionNotDerivedFromPersonnel(option, prevState) {
  return {
    isDerived: false,
    selectedRestorableUserId: prevState.selectedRestorableUserId,
    email: option.value,
    restoredDomainUser: prevState.restoredDomainUser,
    accessType: 'regular',
  };
}

function buildOptionDerivedFromRestorableUser(option) {
  const { attributes, id } = option.restorableUser.data;

  return {
    ...buildDerivedIdentity(attributes),
    selectedRestorableUserId: id,
    accessType:
      attributes.accessType === 'personnel' ? 'regular' : attributes.accessType,
    accessControls: {},
    restoredDomainUser: option.restorableUser,
  };
}

function buildOptionDerivedFromPersonnel(option) {
  const { attributes, relationships } = option.personnel;

  return {
    ...buildDerivedIdentity(attributes),
    selectedRestorableUserId: null,
    restoredDomainUser: null,
    profilePhotoUrl: option.profilePhoto?.links?.croppedUrl,
    personnelUserId: relationships?.user?.data?.id,
    accessType: 'regular',
  };
}

export function buildSelectedAttributes(option, prevState) {
  if (option.__isNew__ || option.isNotDerived) {
    return buildOptionNotDerivedFromPersonnel(option, prevState);
  }

  if (option.__isRestore__) {
    return buildOptionDerivedFromRestorableUser(option);
  }

  return buildOptionDerivedFromPersonnel(option);
}
